import React from 'react';
import { ChevronRight } from 'lucide-react';

const HeroReselling = () => {
  return (
    <section className="pt-1 pb-12 lg:pb-40 px-4">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-center relative">
        
        {/* LEFT CARD: The "Lead Card" */}
        <div className="bg-[#f8f9fa] rounded-[40px] p-12 lg:p-20 w-full lg:w-[50%] shadow-xl z-0 relative flex flex-col justify-center">
          
          {/* Adjusted Heading: Added max-w-md to keep the title compact */}
          <h2 className="text-4xl lg:text-5xl font-extrabold leading-[1.1] mb-8 text-gray-900 max-w-md">
            Tech &  <span className="text-green-600">Reselling</span>
          </h2>
          
          {/* Adjusted Paragraph: Reduced max-w to improve readability and box shape */}
          <p className="text-gray-700 text-lg leading-relaxed mb-10 max-w-sm lg:max-w-[85%]">
            We deliver enterprise-grade security solutions powered by trusted technologies and expert integration, 
            protecting your infrastructure end to end while ensuring scalability, reliability, and resilience against evolving cyber threats.
          </p>
          
          
        </div>

        {/* RIGHT CARD: The "Details Grid" (Overlapping) */}
        <div className="bg-[#020617] rounded-[40px] p-12 lg:p-16 w-full lg:w-[65%] lg:-ml-20 mt-10 lg:mt-0 shadow-2xl z-10 overflow-hidden relative border border-green-500/70 
          lg:translate-y-24 transition-transform duration-500">
          {/* Background Gradient Mesh Effect */}
          <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-br from-blue-900/70 to-transparent pointer-events-none" />
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12 relative z-10">
            
            {/* Section 1 */}
            <div>
              <h3 className="text-white text-xl font-bold mb-4">On-Premise Infrastructure</h3>
              <ul className="space-y-4">
                <li className="flex gap-3 text-gray-400 text-sm leading-relaxed">
                  <ChevronRight size={18} className="text-blue-500 shrink-0 mt-1" />
                  Custom-designed security architectures tailored to your physical environment
                </li>
                <li className="flex gap-3 text-gray-400 text-sm leading-relaxed">
                  <ChevronRight size={18} className="text-blue-500 shrink-0 mt-1" />
                  Full control, visibility, and compliance-ready protection for critical assets
                </li>
              </ul>
            </div>

            {/* Section 2 */}
            <div>
              <h3 className="text-white text-xl font-bold mb-4">Authorized Vendor Solutions</h3>
              <ul className="space-y-4">
                <li className="flex gap-3 text-gray-400 text-sm leading-relaxed">
                  <ChevronRight size={18} className="text-blue-500 shrink-0 mt-1" />
                  Direct access to certified, industry-leading security hardware and software
                </li>
                <li className="flex gap-3 text-gray-400 text-sm leading-relaxed">
                  <ChevronRight size={18} className="text-blue-500 shrink-0 mt-1" />
                  Vendor-backed reliability, updates, and long-term scalability
                </li>
              </ul>
            </div>

            {/* Section 3 */}
            <div>
              <h3 className="text-white text-xl font-bold mb-4">Endpoint Protection</h3>
              <ul className="space-y-4">
                <li className="flex gap-3 text-gray-400 text-sm leading-relaxed">
                  <ChevronRight size={18} className="text-blue-500 shrink-0 mt-1" />
                  Real-time threat detection and response across all endpoints
                </li>
                <li className="flex gap-3 text-gray-400 text-sm leading-relaxed">
                  <ChevronRight size={18} className="text-blue-500 shrink-0 mt-1" />
                  Lightweight, performance-friendly security for devices and servers
                </li>
              </ul>
            </div>

            {/* Section 4 */}
            <div>
              <h3 className="text-white text-xl font-bold mb-4">Network Security</h3>
              <ul className="space-y-4">
                <li className="flex gap-3 text-gray-400 text-sm leading-relaxed">
                  <ChevronRight size={18} className="text-blue-500 shrink-0 mt-1" />
                  Advanced protection against unauthorized access and cyber threats
                </li>
                <li className="flex gap-3 text-gray-400 text-sm leading-relaxed">
                  <ChevronRight size={18} className="text-blue-500 shrink-0 mt-1" />
                  Secure firewalls, intrusion prevention, and network visibility controls
                </li>
              </ul>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default HeroReselling;